<template>
  <div
    class="wrapper"
    @click="closeModal()"
  >
    <div
      class="modal_window"
      @click.stop=""
    >
      <div
        v-if="!hideCloseButton || $slots.heading"
        class="modal_header"
      >
        <h3 class="heading">
          <slot name="heading" />
        </h3>
        <button
          v-if="!hideCloseButton"
          class="btn shadow-none p-0 close_modal_btn"
          @click="closeModal()"
        >
          <svg-vue icon="icons/modal_cross" />
        </button>
      </div>
      <div class="modal_content">
        <slot />
      </div>
      <div
        v-if="$slots.footer"
        class="d-flex align-items-end modal_footer"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hideCloseButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['close'],
  beforeMount() {
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);

  .modal_window {
    background-color: white;
    border-radius: 0.75rem;
    padding: 1.5rem;
    overflow: auto;
    z-index: 101;

    .modal_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1rem;

      .heading {
        font-weight: 700;
        line-height: 1.42;
        letter-spacing: -0.042em;
        color: #040707;
        font-size: 1.5rem;
        margin-bottom: 0;
      }

      .close_modal_btn {
        cursor: pointer;

        svg {
          height: 32px;
          width: 32px;
        }
      }
    }

    .modal_content {
      z-index: 101;
      max-height: 70vh;
      overflow-x: auto;
    }

    .modal_footer {
      margin-top: .5rem;
    }
  }
}
</style>
